import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" The "),
  /*#__PURE__*/_createElementVNode("code", null, "style"),
  /*#__PURE__*/_createTextVNode(" tag of single-file-components should get the "),
  /*#__PURE__*/_createElementVNode("code", null, "scoped"),
  /*#__PURE__*/_createTextVNode(" attribute by default. Sometimes (e.g. on #app-level) it might make sense to not use it. There is another way to keep CSS-classes local, using class bindings and "),
  /*#__PURE__*/_createElementVNode("code", null, "<style module>"),
  /*#__PURE__*/_createTextVNode(" For the paragraph below, the code looks like this ")
], -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Test Code ")

import {ref, getCurrentInstance, computed} from "vue";
import { useRouter } from "vue-router";
import BaseCodeBlock from '@/components/BaseCodeBlock.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const thisCompo = getCurrentInstance();
const headlineStyle = ref(false);
const styles = thisCompo?.ctx.$options.__cssModules.$style;

const changeClass = () => {
  console.log("Styles", styles);
  console.log(typeof(thisCompo))
  headlineStyle.value = !headlineStyle.value
}

const toggleThisHeadline = computed(() => {
  // return headlineStyle.value ? getCurrentInstance()?.ctx.$options.__cssModules.$style.explosive : getCurrentInstance()?.ctx.$options.__cssModules.$style.boring;
  return headlineStyle.value ? styles.explosive : styles.boring;
})

const router = useRouter();
const goToInputStyling = () => {
  router.push({name: 'Input styles'});
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", { onClick: goToInputStyling }, "Click here for input styling"),
    _hoisted_1,
    _createVNode(BaseCodeBlock, { description: 'Test description' }, {
      "my-code": _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("p", {
      class: _normalizeClass(_ctx.$style.explosive)
    }, " An explosive text using css modules. " + _toDisplayString(_ctx.$style.color) + ". With :export css values are accessible via $style.... ", 3),
    _createElementVNode("p", {
      class: _normalizeClass(_ctx.$style.boring)
    }, "Modules are compiled at compile time. No browser issues!", 2),
    _createElementVNode("button", { onClick: changeClass }, "Toggle style"),
    _createElementVNode("h2", {
      class: _normalizeClass(_unref(toggleThisHeadline))
    }, "Headline", 2),
    _createElementVNode("pre", null, _toDisplayString(_ctx.$style), 1)
  ], 64))
}
}

})